import React from 'react';

const TextAreaEditorSection = props => (
  <textarea {...props} />
);

export default TextAreaEditorSection;
